
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendar/training",
      function () {
        return require("private-next-pages/calendar/training.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendar/training"])
      });
    }
  